import { render } from "./App.vue?vue&type=template&id=20f7d231"
const script = {}

import "./App.vue?vue&type=style&index=0&id=20f7d231&lang=scss"
script.render = render

export default script